import { apiClient } from "../config";

async function archiveOrRestoreMarkerGroup(id: any, status: any) {
  const url = `/admin/marker-groups/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreMarkerGroup;
